// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectCard_card__2Hqqx {
  position: relative;
  display: flex;
  align-items: center;
  height: 338rem;
  width: 100%;
  gap: 32rem;
  padding: 42rem;
  background-color: #ffffff;
  border: 1px solid #E3E8EF;
  border-radius: 8rem;
  overflow: hidden;
}
@media only screen and (max-width: 700px) {
  .ProjectCard_card__2Hqqx {
    flex-direction: column;
    height: fit-content;
    padding: 32rem;
    gap: 16rem;
  }
}
.ProjectCard_card__2Hqqx .ProjectCard_content__8bLNP {
  position: relative;
  z-index: 2;
}
.ProjectCard_card__2Hqqx .ProjectCard_image__jjG52 {
  height: 254rem;
  width: 254rem;
  object-fit: cover;
  object-position: center;
  border-radius: 4rem;
  flex: none;
}
@media only screen and (max-width: 700px) {
  .ProjectCard_card__2Hqqx .ProjectCard_image__jjG52 {
    height: auto;
    width: 100%;
    aspect-ratio: 1/1;
  }
}
.ProjectCard_card__2Hqqx .ProjectCard_title__nuL1y {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32rem;
  line-height: 42rem;
  color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .ProjectCard_card__2Hqqx .ProjectCard_title__nuL1y {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18rem;
    line-height: 32rem;
    color: #1d2939;
  }
}
.ProjectCard_card__2Hqqx .ProjectCard_caption__UJMDd {
  display: block;
  margin-top: 16rem;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24rem;
  line-height: 28rem;
  color: #47C4F0;
}
@media only screen and (max-width: 700px) {
  .ProjectCard_card__2Hqqx .ProjectCard_caption__UJMDd {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14rem;
    line-height: 18rem;
    color: #47C4F0;
  }
}
.ProjectCard_card__2Hqqx .ProjectCard_description__gfC2w {
  margin-top: 4rem;
}
.ProjectCard_card__2Hqqx .ProjectCard_description__gfC2w * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24rem;
  line-height: 28rem;
  color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .ProjectCard_card__2Hqqx .ProjectCard_description__gfC2w * {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 24rem;
    color: #1d2939;
  }
}
.ProjectCard_card__2Hqqx .ProjectCard_description__gfC2w strong, .ProjectCard_card__2Hqqx .ProjectCard_description__gfC2w b {
  font-weight: 600;
}
.ProjectCard_card__2Hqqx .ProjectCard_pattern__rf6W3 {
  position: absolute;
  height: 100%;
  bottom: 0;
  right: 0;
  width: auto;
  z-index: 1;
}
@media only screen and (max-width: 700px) {
  .ProjectCard_card__2Hqqx .ProjectCard_pattern__rf6W3 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Projects/styles/ProjectCard.module.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,yBCyBM;EDxBN,yBAAA;EACA,mBAAA;EACA,gBAAA;AAFF;AE8HE;EFvIF;IAcI,sBAAA;IACA,mBAAA;IACA,cAAA;IACA,UAAA;EADF;AACF;AAGE;EACE,kBAAA;EACA,UAAA;AADJ;AAIE;EACE,cAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAFJ;AE0GE;EF9GA;IAQI,YAAA;IACA,WAAA;IACA,iBAAA;EAAJ;AACF;AAGE;EEvCA,iCDFU;ECGV,kBAAA;EACA,gBFsCkC;EErClC,gBAAA;EACA,kBAAA;EACA,cDKS;ADkCX;AE2FE;EFhGA;IEvCA,iCDFU;ICGV,kBAAA;IACA,gBFwCoC;IEvCpC,gBAAA;IACA,kBAAA;IACA,cDKS;ED2CT;AACF;AARE;EACE,cAAA;EACA,iBAAA;EEhDF,iCDFU;ECGV,kBAAA;EACA,gBAH0D;EAI1D,gBAAA;EACA,kBAAA;EACA,cDSK;ADkDP;AEuEE;EFzFA;IE9CA,iCDFU;ICGV,kBAAA;IACA,gBAH0D;IAI1D,gBAAA;IACA,kBAAA;IACA,cDSK;ED2DL;AACF;AAnBE;EACE,gBAAA;AAqBJ;AAnBI;EE1DF,iCDFU;ECGV,kBAAA;EACA,gBAH0D;EAI1D,gBAAA;EACA,kBAAA;EACA,cDKS;AD2EX;AEkDE;EF7EE;IE1DF,iCDFU;ICGV,kBAAA;IACA,gBAH0D;IAI1D,gBAAA;IACA,kBAAA;IACA,cDKS;EDoFT;AACF;AA9BI;EACE,gBAAA;AAgCN;AA5BE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AA8BJ;AE6BE;EFjEA;IAQI,aAAA;EAgCJ;AACF","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n.card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 338rem;\n  width: 100%;\n  gap: 32rem;\n  padding: 42rem;\n  background-color: $white;\n  border: 1px solid #E3E8EF;\n  border-radius: 8rem;\n  overflow: hidden;\n\n  @include mobile {\n    flex-direction: column;\n    height: fit-content;\n    padding: 32rem;\n    gap: 16rem;\n  }\n\n  .content {\n    position: relative;\n    z-index: 2;\n  }\n\n  .image {\n    height: 254rem;\n    width: 254rem;\n    object-fit: cover;\n    object-position: center;\n    border-radius: 4rem;\n    flex: none;\n    @include mobile {\n      height: auto;\n      width: 100%;\n      aspect-ratio: 1 / 1;\n    }\n  }\n\n  .title {\n    @include fnt(32, 42, $gray-800, 600);\n    @include mobile {\n      @include fnt(18, 32, $gray-800, 600);\n    }\n  }\n\n  .caption {\n    display: block;\n    margin-top: 16rem;\n    @include fnt(24, 28, $main);\n    @include mobile {\n      @include fnt(14, 18, $main);\n    }\n  }\n\n  .description {\n    margin-top: 4rem;\n\n    * {\n      @include fnt(24, 28, $gray-800);\n      @include mobile {\n        @include fnt(16, 24, $gray-800);\n      }\n    }\n\n    strong, b {\n      font-weight: 600;\n    }\n  }\n\n  .pattern {\n    position: absolute;\n    height: 100%;\n    bottom: 0;\n    right: 0;\n    width: auto;\n    z-index: 1;\n    @include mobile {\n      display: none;\n    }\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `ProjectCard_card__2Hqqx`,
	"content": `ProjectCard_content__8bLNP`,
	"image": `ProjectCard_image__jjG52`,
	"title": `ProjectCard_title__nuL1y`,
	"caption": `ProjectCard_caption__UJMDd`,
	"description": `ProjectCard_description__gfC2w`,
	"pattern": `ProjectCard_pattern__rf6W3`
};
export default ___CSS_LOADER_EXPORT___;
